import { render, staticRenderFns } from "./CustomerTerms.vue?vue&type=template&id=47af71be&scoped=true"
import script from "./CustomerTerms.vue?vue&type=script&lang=js"
export * from "./CustomerTerms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47af71be",
  null
  
)

export default component.exports